import { forEach as _forEach } from 'lodash';
import React from 'react';
import { Table } from 'react-bootstrap';
import { FormattedNumber, injectIntl } from 'react-intl';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getDescriptionInCurrentLanguage, getNameInCurrentLanguage} from "helpers/intl";
import ReactHtmlParser from "react-html-parser";


class PositionsInfos extends React.Component {
  round = (number, precision) => {
    let factor = Math.pow(10, precision);
    let tempNumber = number * factor;
    let roundedTempNumber = Math.round(tempNumber);

    return roundedTempNumber / factor;
  };

  showPositionVatRate = position => {
    if (position.vat_rate >= 0) {
      return <FormattedNumber value={position.vat_rate / 100} style="percent" />;
    } else {
      return 'n/a';
    }
  };

  getNumericVatRate = position => {
    return position.vat_rate < 0 ? 0 : position.vat_rate;
  };

  render() {
    const { intl, doc } = this.props;
    const messages = intl.messages;

    return (
      <Table responsive class="invoiceFormat">
        <thead>
          <tr>
            <th>{messages.salesDoc.name}</th>
            <th>{messages.salesDoc.description}</th>
            <th>{messages.salesDoc.unit_price}</th>
            <th>{doc.owner_data.vat_name} %</th>
            <th>{messages.salesDoc.quantity}</th>
          </tr>
        </thead>
        <tbody>
          {doc.positions.map((position, i) => {
            let unitCount = [];
            if (position.variant) {
              const attributes = position.variant.attributes
              if (attributes && attributes.length > 0) {
                _forEach(attributes, (attribute, i) => {
                  const names = attribute.name
                  const values = attribute.values
                  if (names && values && names.length <= values.length)
                  {
                    _forEach(names, (name, i) => {
                      const name2 = name.name
                      const values2 = attribute.values[i].value
                      if (name2 && values2 && values2.length > 0) {
                        const value2 = values2[0].name
                        unitCount.push(
                          ((unitCount.length <= 1) ? ' ' : '  ') + name2 + ': ' + value2
                        );
                      }
                    })
                  }
                })
              }
            }
            let description = (position.description && position.description.length > 0) ? position.description : '';
            if (position.shipping_method && position.shipping_method.length > 0) {
              description += ((description.length > 0) ? ', ' : '') + messages.delivery_time + ': ' + position.shipping_method;
            }
            if (unitCount.length > 0) {
              description += ((description.length > 0) ? ', ' : '') + unitCount;
            }
            return (
              <tr key={i}>
                <td>{position.name}</td>
                <td>{ReactHtmlParser(position?.description)}</td>
                <td>
                  <FormattedNumber value={position.net_price} style="currency" currency={doc.currency} />
                </td>
                <td>{this.showPositionVatRate(position)}</td>
                <td>{position.quantity}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};


export default withRouter(
  injectIntl(
    connect(
      mapStateToProps
    )(PositionsInfos)
  )
);
